import { Injectable } from '@angular/core';
import {AbstractPeriodParametersLoaderService} from '../../services/abstract-period-parameters-loader.service';
import {DiningRoomsAndRentParameters} from './dining-rooms-and-rent-parameters';

@Injectable({
  providedIn: 'root'
})
export class DiningRoomsAndRentParametersLoaderService extends AbstractPeriodParametersLoaderService<DiningRoomsAndRentParameters>{

  constructor() {
      super('diningRoomsAndRent')
  }
}
